import { render, staticRenderFns } from "./shRecord.vue?vue&type=template&id=20bd88e2"
import script from "./shRecord.vue?vue&type=script&lang=js"
export * from "./shRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports